import { FC, useMemo } from "react";
import DetailsSectionColumn, {
  DetailsSectionColumnProps,
} from "./DetailsSectionColumn";
import Row from "../../../../Grid/Row";

interface DetailsSectionColumnsProps {
  columns: DetailsSectionColumnProps["rows"][];
}

const DetailsSectionColumns: FC<DetailsSectionColumnsProps> = ({ columns }) => {
  const colSpan = useMemo(() => 12 / (columns.length || 1), [columns.length]);
  return (
    <Row>
      {columns.map((column, index) => {
        return (
          <DetailsSectionColumn
            xs={12}
            md={colSpan}
            key={index}
            rows={column}
          />
        );
      })}
    </Row>
  );
};

export default DetailsSectionColumns;
